import { render } from "./ResourceSeatingCapacity.vue?vue&type=template&id=6d0f4acb&scoped=true"
import script from "./ResourceSeatingCapacity.vue?vue&type=script&lang=js"
export * from "./ResourceSeatingCapacity.vue?vue&type=script&lang=js"

import "./ResourceSeatingCapacity.vue?vue&type=style&index=0&id=6d0f4acb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d0f4acb"]])

export default __exports__